import { AvatarSize } from '../Avatar';
import { BadgeSize } from '../Badge';
import { SpaceVariant } from '../Spacer';
import { TypographyVariant } from '../Typography';
export var getTitleVariant = function getTitleVariant(size) {
  switch (size) {
    case AvatarSize.X_LARGE:
    case AvatarSize.LARGE:
      return TypographyVariant.SUBHEADING;

    case AvatarSize.MEDIUM:
    case AvatarSize.SMALL:
      return TypographyVariant.SUBHEADING_2;

    case AvatarSize.X_SMALL:
      return TypographyVariant.CAPTION;

    default:
      return undefined;
  }
};
export var getSubTitleVariant = function getSubTitleVariant(size) {
  switch (size) {
    case AvatarSize.X_LARGE:
    case AvatarSize.LARGE:
      return TypographyVariant.BODY_2;

    default:
      return TypographyVariant.CAPTION_2;
  }
};
export var getSpaceVariant = function getSpaceVariant(size) {
  switch (size) {
    case AvatarSize.X_LARGE:
      return SpaceVariant.S;

    case AvatarSize.LARGE:
    case AvatarSize.MEDIUM:
      return SpaceVariant.XS;

    case AvatarSize.SMALL:
    case AvatarSize.X_SMALL:
      return SpaceVariant.XXS;

    default:
      return SpaceVariant.S;
  }
};
export var getBadgeSize = function getBadgeSize(size) {
  switch (size) {
    case AvatarSize.X_LARGE:
      return BadgeSize.X_LARGE;

    case AvatarSize.LARGE:
      return BadgeSize.LARGE;

    case AvatarSize.MEDIUM:
      return BadgeSize.MEDIUM;

    case AvatarSize.SMALL:
      return BadgeSize.SMALL;

    case AvatarSize.X_SMALL:
      return BadgeSize.X_SMALL;

    default:
      return BadgeSize.MEDIUM;
  }
};